import React, { Component } from 'react';
import { Input } from '../inputs';

export default class CustomDatePicker extends Component {
  render() {
    const { ...props } = this.props;

    return <Input type="text" placeholder="DD.MM.YYYY" {...props} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/inputs/DatePicker.js